import type { RenderProps } from "../../common/types";

export default function dateRangeRenderer({ value }: RenderProps) {
  const { start, end } = (value as { start: string; end: string }) || {};
  if (!start && !end) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  return (
    <p className="break-normal whitespace-pre-wrap text-size-body">
      {start} {" -> "} {end}
    </p>
  );
}
